module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "message",
      "duration": {
        enter: 750,
        leave: 250
      }
    }
  }, [_c('span', {
    staticClass: "rf-message error"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8faa6ffe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frontend/components/RfMessage.vue
// module id = 261
// module chunks = 0